import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getInitializeInstanceByGuid } from '../index';
export const useGetInitializeInstanceByGuid = (guid, enabled) => useQuery(['GetInitializeInstanceByGuid', guid], () => trackPromise(getInitializeInstanceByGuid(guid)), {
    cacheTime: 0,
    enabled,
});
